/*
 *
 * Header / Menu
 *
 */

import Headroom from 'headroom.js';
import {ready} from "../utils/ready";

const init = () => {

  // Headroom
  const headerBanner = document.getElementById('header');
  const options = {
    tolerance : 16,
  };
  const headroom  = new Headroom(headerBanner, options);

  headroom.init();



  // Hamburger Menu Show/Hide
  const menuControls = document.querySelectorAll('#main-nav-btn, .bg-overlay');

  for (let i = 0; i < menuControls.length; i++) {
    menuControls[i].addEventListener('click', () => {
      document.body.classList.toggle('menu-visible');
      menuControls[i].classList.toggle('menu-close');

      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);

      if ( document.body.classList.contains('menu-visible') ) {
        document.body.style =
          'overflow-y:hidden; position: relative; margin-right: var(--widthReflow);';
      } else {
        document.body.style =
          'overflow-y:visible; position: static; margin-right: 0;';
      }
    });
  }



  // Sub Menu Show/Hide
  const createCloseBtn = () => {
    const closeBtn = document.createElement('span');
    closeBtn.className = 'sub-menu-btn-close';
    closeBtn.textContent = '➔';
    return closeBtn;
  }

  const toggleSubMenu = (listItem, force) => {
    listItem.classList.toggle('sub-menu-visible', force)
  }

  const itemsWithSubmenus = document.querySelectorAll('.nav-primary .nav li.menu-item-has-children');

  const breakpoint = getComputedStyle(document.body).getPropertyValue('--theme--screens--desktop-menu').trim();
  const mediaQuery = window.matchMedia(`(min-width: ${breakpoint})`);
  let isDesktopMenu = mediaQuery.matches;

  mediaQuery.addEventListener('change', (e) => {
    console.log('change', e.matches);
    isDesktopMenu = e.matches;
  });

  console.log({
    breakpoint,
    mediaQuery,
    isDesktopMenu,
  })

  Array.from(itemsWithSubmenus).forEach((listItem) => {
    listItem.addEventListener('mouseenter', () => {
      if (isDesktopMenu) {
        toggleSubMenu(listItem, true);
      }
    });
    listItem.addEventListener('mouseleave', () => {
      if (isDesktopMenu) {
        toggleSubMenu(listItem, false);
      }
    });
    const subMenuBtn = listItem.querySelector('.sub-menu-btn');
    const subMenu = listItem.querySelector('.sub-menu');
    const link = listItem.querySelector('a');
    const header = link.cloneNode(true);
    header.classList.add('sub-menu-header');
    const list = listItem.parentElement;
    const closeBtn = createCloseBtn();
    subMenu.prepend(header);
    subMenu.prepend(closeBtn);
    subMenuBtn.addEventListener('click', () => {
      if (! isDesktopMenu) {
        toggleSubMenu(listItem, true);
        list.classList.add('sub-menu-drawer-visible');
      }
    });
    closeBtn.addEventListener('click', () => {
      if (! isDesktopMenu) {
        toggleSubMenu(listItem, false);
        list.classList.remove('sub-menu-drawer-visible');
      }
    });
  });
}

ready(init);
